import { AdapterClient } from "@formant/core/client/AdapterClient";
import { AiClient } from "@formant/core/client/AiClient";
import { AnalyticsClient } from "@formant/core/client/AnalyticsClient";
import { AnalyticsModuleClient } from "@formant/core/client/AnalyticsModuleClient";
import { AnnotationClient } from "@formant/core/client/AnnotationClient";
import { AnnotationTemplateClient } from "@formant/core/client/AnnotationTemplateClient";
import { AuthClient } from "@formant/core/client/AuthClient";
import { ChannelClient } from "@formant/core/client/ChannelClient";
import { CommandClient } from "@formant/core/client/CommandClient";
import { CommandRequestClient } from "@formant/core/client/CommandRequestClient";
import { CommentClient } from "@formant/core/client/CommentClient";
import { CountClient } from "@formant/core/client/CountClient";
import { DeviceClient } from "@formant/core/client/DeviceClient";
import { DeviceConfigurationTemplateClient } from "@formant/core/client/DeviceConfigurationTemplateClient";
import { DeviceDetailsClient } from "@formant/core/client/DeviceDetailsClient";
import { DocumentRagServiceClient } from "@formant/core/client/DocumentRagServiceClient";
import { EventClient } from "@formant/core/client/EventClient";
import { EventTriggerClient } from "@formant/core/client/EventTriggerClient";
import { FileClient } from "@formant/core/client/FileClient";
import { GatewayClient } from "@formant/core/client/GatewayClient";
import { GroupClient } from "@formant/core/client/GroupClient";
import { IngestionClient } from "@formant/core/client/IngestionClient";
import { IntegrationClient } from "@formant/core/client/IntegrationClient";
import { InterventionRequestClient } from "@formant/core/client/InterventionRequestClient";
import { InterventionResponseClient } from "@formant/core/client/InterventionResponseClient";
import { KeyringClient } from "@formant/core/client/KeyringClient";
import { KeyValueClient } from "@formant/core/client/KeyValueClient";
import { MetadataClient } from "@formant/core/client/MetadataClient";
import { ModuleClient } from "@formant/core/client/ModuleClient";
import { ModuleConfigurationClient } from "@formant/core/client/ModuleConfigurationClient";
import { OnlineDevicesClient } from "@formant/core/client/OnlineDevicesClient";
import { OrganizationClient } from "@formant/core/client/OrganizationClient";
import { PresenceClient } from "@formant/core/client/PresenceClient";
import { QueryClient } from "@formant/core/client/QueryClient";
import { RoleClient } from "@formant/core/client/RoleClient";
import { RtcSignalingClient } from "@formant/core/client/RtcSignalingClient";
import { ScheduleClient } from "@formant/core/client/ScheduleClient";
import { SeekClient } from "@formant/core/client/SeekClient";
import { ShareClient } from "@formant/core/client/ShareClient";
import { SimulatorServiceClient } from "@formant/core/client/SimulatorServiceClient";
import { SsoClient } from "@formant/core/client/SsoClient";
import { StreamClient } from "@formant/core/client/StreamClient";
import { StreamCurrentValueClient } from "@formant/core/client/StreamCurrentValueClient";
import { SystemEventClient } from "@formant/core/client/SystemEventClient";
import { TagTemplateClient } from "@formant/core/client/TagTemplateClient";
import { TeamClient } from "@formant/core/client/TeamClient";
import { TeleopViewClient } from "@formant/core/client/TeleopViewClient";
import { TheopolisClient } from "@formant/core/client/TheopolisClient";
import { UsageMetricsClient } from "@formant/core/client/UsageMetricsClient";
import { UserClient } from "@formant/core/client/UserClient";
import { ViewClient } from "@formant/core/client/ViewClient";
import { WorkflowClient } from "@formant/core/client/WorkflowClient";
import { documentServiceBaseUrl } from "@formant/core/common";
import { namespace } from "@formant/core/common/config";
import { duration } from "@formant/core/model/duration";
import { SignalingPromiseClient } from "@formant/protos";

import { AgentVersionClient } from "./client/AgentVersionClient";
import { ReorderableCommandTemplateClient } from "./client/ReorderableCommandTemplateClient";
import {
    adminApi,
    gatewayApiUrl,
    ingestionApi,
    queryApi,
    signalingApi,
    signalingApiV2,
    SimulatorService,
} from "./config";

export const authClient = new AuthClient(adminApi, {
    timeoutMs: 10 * duration.second,
});
export const roleClient = new RoleClient(adminApi);
export const eventTriggerClient = new EventTriggerClient(adminApi);
export const channelClient = new ChannelClient(adminApi);
export const agentVersionClient = new AgentVersionClient(adminApi);
export const deviceClient = new DeviceClient(adminApi);
export const deviceDetailsClient = new DeviceDetailsClient(adminApi);
export const eventClient = new EventClient(adminApi);
export const userClient = new UserClient(adminApi);
export const teamClient = new TeamClient(adminApi);
export const scheduleClient = new ScheduleClient(adminApi);
export const interventionRequestClient = new InterventionRequestClient(
    adminApi,
);
export const interventionResponseClient = new InterventionResponseClient(
    adminApi,
);
export const gatewayClient = new GatewayClient(gatewayApiUrl);
export const keyringClient = new KeyringClient(adminApi);
export const usageMetricsClient = new UsageMetricsClient(queryApi);
export const ssoClient = new SsoClient(adminApi);

export const queryClient = new QueryClient(queryApi);
export const metadataClient = new MetadataClient(queryApi);
export const presenceClient = new PresenceClient(queryApi);
export const seekClient = new SeekClient(queryApi);
export const onlineDevicesClient = new OnlineDevicesClient(queryApi);
export const countClient = new CountClient(queryApi);
export const organizationClient = new OrganizationClient(adminApi);
export const integrationClient = new IntegrationClient(adminApi);
export const ingestionClient = new IngestionClient(ingestionApi);
export const analyticsClient = new AnalyticsClient(queryApi);
export const shareClient = new ShareClient(adminApi);
export const rtcSignalingClient = new RtcSignalingClient(signalingApi);
export const signalingV2Client = new SignalingPromiseClient(
    signalingApiV2,
    null,
    null,
);
export const deviceConfigurationTemplateClient =
    new DeviceConfigurationTemplateClient(adminApi);
export const viewClient = new ViewClient(adminApi);
export const teleopViewClient = new TeleopViewClient(adminApi);
export const workflowClient = new WorkflowClient(
    "https://workflows-one.vercel.app",
);
export const aiClient = new AiClient(
    namespace === "prod"
        ? "https://ai-service-prod-c58bf98ddfe8.herokuapp.com"
        : "https://ai-service-dev-7274792f5b10.herokuapp.com",
);
export const theopolisClient = new TheopolisClient(
    namespace === "prod"
        ? "https://theopolis.formant.io"
        : namespace === "stage"
          ? "https://theopolis-stage.formant.io"
          : "https://theopolis-dev.formant.io",
);
export const commandTemplateClient = new ReorderableCommandTemplateClient(
    adminApi,
);
export const commandClient = new CommandClient(adminApi);
export const systemEventClient = new SystemEventClient(adminApi);
export const commandRequestClient = new CommandRequestClient(adminApi);
export const commentClient = new CommentClient(adminApi);
export const annotationClient = new AnnotationClient(adminApi);
export const annotationTemplateClient = new AnnotationTemplateClient(adminApi);
export const groupClient = new GroupClient(adminApi);
export const tagTemplateClient = new TagTemplateClient(adminApi);
export const streamClient = new StreamClient(adminApi);
export const streamCurrentValueClient = new StreamCurrentValueClient(queryApi);
export const fileClient = new FileClient(adminApi);
export const adapterClient = new AdapterClient(adminApi);
export const moduleClient = new ModuleClient(adminApi);
export const moduleConfigurationClient = new ModuleConfigurationClient(
    adminApi,
);
export const simulatorServiceClient = new SimulatorServiceClient(
    SimulatorService,
);
export const analyticsModuleClient = new AnalyticsModuleClient(adminApi);
export const keyValueClient = new KeyValueClient(adminApi);
export const documentRagServiceClient = new DocumentRagServiceClient(
    documentServiceBaseUrl,
    { timeoutMs: 10 * duration.second },
);
